import { makeStyles, createStyles, Theme } from "@material-ui/core";

export const useDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(2, 2),
      width: "100%",
    },
    text: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "14px",
      lineHeight: "20px",
    },
    header: {
      color: "#273A39",
      fontSize: "22px",
      lineHeight: "30px",
      fontWeight: "bold",
    },
    content: {
      width: "100%"
    },
    buttons: {
      alignSelf: "flex-start",
      padding: "0px 25px"
    },
    button: {
      padding: "6px 16px",
      borderRadius: "4px",
      borderStyle: "solid",
      color: theme.palette.common.white,
      fontWeight: "bold",
      fontSize: "1rem",
      textTransform: "none"
    },
  })
);
